import React from 'react';
import Parse from 'html-react-parser';
import { createSelector } from 'reselect';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import UserStore from '../../../../stores/UserStore';
import {
    getStatus,
    getDataCurrency,
    getPaymentMethod,
    getPaymentSystem
} from '../../../../helpers/common';

const payout = (state) => state.publisherPayouts.item;
const loading = (state) => state.publisherPayouts.loading;
const currency = (state) => state.currency.list;
const paymentMethods = (state) => state.paymentMethods;
const paymentSystems = (state) => state.paymentSystems;

export const isEmpty = createSelector(
    payout,
    (payout = {}) => {
        return !Object.keys(payout).length;
    }
);

export const mainSelector = createSelector(
    payout,
    loading,
    currency,
    paymentMethods,
    paymentSystems,
    (payout = {}, loading, currency = [], paymentMethods = [], paymentSystems = []) => {
        if (!Object.keys(payout).length || loading) return;

        const payoutNames = UserStore.getTranslation().payoutPage;
        const paymentMethod = getPaymentMethod(payout.payment_method_details.payment_method);

        return {
            common: {
                id: payout.id,
                status: getStatus(payout.status),
                createdAt: I18nFormatter.fullDateTime(payout.created_at),
                updatedAt: I18nFormatter.fullDateTime(payout.updated_at),
                writingDownSum: I18nFormatter.currency(payout.sum_original.amount, payout.sum_original.currency, true),
                payoutSum: I18nFormatter.currency(payout.sum.amount, payout.sum.currency, true),
                commission: I18nFormatter.currency(payout.fee.amount, payout.fee.currency, true),
                comment: payout.comment,
                note: Parse(`${payoutNames.affiliatePayout}<br/>${I18nFormatter.fullDateTime(payout.from_dt)} &mdash; ${I18nFormatter.fullDateTime(payout.created_at)}`)
            },
            paymentMethod: {
                system: getPaymentSystem(paymentMethod.payment_system).title || '',
                currency:  paymentMethod.currency || '',
                account: payout.payment_method_details.number
            },
            currency: getDataCurrency(payout.currency_ratio)
        };
    }
);
